export var StepContentOverrides = function (theme) {
    var _a;
    return ({
        MuiStepContent: {
            root: (_a = {
                    marginTop: '5px',
                    '& button + button': {
                        marginLeft: '2px',
                    },
                    marginLeft: 0,
                    borderLeft: 'none',
                    paddingLeft: 0
                },
                _a[theme.breakpoints.up('sm')] = {
                    marginLeft: '7px',
                    borderLeft: "2px solid ".concat(theme.palette.secondary.main),
                    paddingLeft: '15px',
                },
                _a),
            last: {
                borderLeftColor: 'transparent',
            },
        },
    });
};
//# sourceMappingURL=StepContent.overrides.js.map